import {AnticipationShakeDuration} from "sg-consts";
import screenShakeComponent from "slotworks/components/effects/screen-shake-component";
import SpinReelTransition from "slotworks/components/matrix/reel/transition-behaviours/spin/spin-reel-transition";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import Contract from "slotworks/utils/contracts/contract";
import SGReelComponent from "../../sg-reel-component";
import SGReelSpinner from "./sg-reel-spinner";

export default class SGSpinReelTransition extends SpinReelTransition {

    protected createReelSpinner(reel: SGReelComponent, reelstop: number, reelstrip: string[]): SGReelSpinner {
        const spinner: SGReelSpinner = new SGReelSpinner(reel, reelstop, reelstrip);
        spinner.screenShaking.add(() => {
            screenShakeComponent.shakeScreen(AnticipationShakeDuration).execute();
        });
        return spinner;
    }

    public skip(spinRecord: SpinRecord): Contract<void> {
        this.getSpinners().forEach(spiner => {
            (spiner as SGReelSpinner).stopAnticipation();
        });
        screenShakeComponent.stopShakeScreen();
        return super.skip(spinRecord);
    }
}
